import * as actionTypes from './actionTypes'
import * as API from '../api/SendResume'

export const sendResumeAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.RESUME_POST_TO_REQUEST, payload: data})
        return API.resumeSendTo(data)
            .then(response => {            	
            	dispatch({type: actionTypes.RESUME_POST_TO_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.RESUME_POST_TO_ERROR, payload:error})    
            })
    }
}


export const resumeListAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.RESUME_LIST_REQUEST, payload: data})
        return API.resumeList(data)
            .then(response => {             
                dispatch({type: actionTypes.RESUME_LIST_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.RESUME_LIST_ERROR, payload:error})    
            })
    }
}

export const deleteResumeAction = (data) => {
    return dispatch => {
        dispatch({type: actionTypes.RESUME_DELETE_REQUEST, payload: data})
        return API.deleteResumeApi(data)
            .then(response => {             
                dispatch({type: actionTypes.RESUME_DELETE_SUCCESS, payload: response})                
            })
            .catch(error => {
                dispatch({type: actionTypes.RESUME_DELETE_ERROR, payload:error})    
            })
    }
}







// WEBPACK FOOTER //
// ./src/actions/SendResume.js